import { useMemo } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SectionHeading from '@/components/feature/SectionHeading';
import NewsCard from '@/components/feature/NewsCard';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import TodayPicks from '@/pages/home/components/TodayPicks';
import HotContent from '@/pages/home/components/HotContent';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { getFeaturedArticles, getHotArticles, getLatestArticles, getArticlesByCategory, getCategoryName } from '@/utils/news';
import { useSeo } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: '9·1牛网 - 全方位资讯与内容服务平台',
    description:
      '9·1牛网提供丰富多样的资讯内容，涵盖新闻、娱乐、生活等多个领域，满足用户多样化的信息需求。用户可在这里获取最新资讯和实用内容。',
    keywords: '9·1牛网,资讯平台,新闻,娱乐,生活,内容服务,信息获取',
  });

  const featured = useMemo(() => getFeaturedArticles(4), []);
  const latest = useMemo(() => getLatestArticles(6), []);
  const hot = useMemo(() => getHotArticles(8), []);
  const newsPicks = useMemo(() => getArticlesByCategory('news').slice(0, 3), []);
  const entPicks = useMemo(() => getArticlesByCategory('entertainment').slice(0, 3), []);
  const lifePicks = useMemo(() => getArticlesByCategory('life').slice(0, 3), []);

  const channelSections = [
    { key: 'news', name: getCategoryName('news'), icon: 'ri-newspaper-line', articles: newsPicks },
    { key: 'entertainment', name: getCategoryName('entertainment'), icon: 'ri-movie-2-line', articles: entPicks },
    { key: 'life', name: getCategoryName('life'), icon: 'ri-leaf-line', articles: lifePicks },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full px-4 md:px-8 py-6 md:py-8 space-y-10 md:space-y-14">
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2">
            <HeroCarousel articles={featured} />
          </div>
          <div className="lg:col-span-1">
            <HotContent articles={hot.slice(0, 6)} />
          </div>
        </section>

        <section>
          <SectionHeading title="分类快捷入口" subtitle="选择你感兴趣的频道" icon="ri-apps-2-line" />
          <CategoryEntries />
        </section>

        <TodayPicks articles={latest} />

        <section>
          <SectionHeading title="频道精选" subtitle="各频道最新看点" icon="ri-layout-grid-line" />
          <div className="space-y-8">
            {channelSections.map((sec) => (
              <div key={sec.key}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="inline-flex items-center gap-2 font-heading font-bold text-base md:text-lg text-foreground-950">
                    <i className={`${sec.icon} text-primary-600`} />
                    {sec.name}频道
                  </h3>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                  <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                    {sec.articles.slice(0, 2).map((a) => (
                      <NewsCard key={a.id} article={a} />
                    ))}
                  </div>
                  <div className="lg:col-span-1 space-y-3">
                    {sec.articles.map((a) => (
                      <NewsCard key={`row-${a.id}`} article={a} variant="row" />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}